export class Address {
  latitude: number | undefined;
  longitude: number | undefined;
  google_place_id: string | undefined;
  formated_address: string | undefined;
  icon: string | undefined;
}
